module.exports = __webpack_public_path__ + "static/media/bounce.01918f96.png";